import React from "react";
import { getStrainTheme } from "../../common/utils/strainTheme";

interface Props {
  type: string;
}

const StrainChip: React.FC<Props> = ({ type }) => {
  const { textColor, backgroundColor } = getStrainTheme(type);

  return (
    <span
      style={{
        color: textColor,
        backgroundColor: backgroundColor,
        padding: "4px 10px",
        borderRadius: "8px",
        fontSize: "12px",
        fontWeight: 500,
        display: "inline-block",
        textAlign: "center",
      }}
    >
      {type || "-"}
    </span>
  );
};

export default StrainChip;
